function Logo(){
    return <>
        <div className="banner-logo col-md-3">
            <a href="/">
                <img src="assets/burke-contractors-logo.png" /> 
            </a>
        </div>
    </>
}
export default Logo